module.exports = __webpack_public_path__ + "static/rank-title.97ddfc7f.png";